import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/mention/style/index.js
// module id = 1764
// module chunks = 0